<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'News'"></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<div class="banner_el"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img src="../../assets/img/news/banner_1.webp" />
					<div class="msg_box">
						<div class="title"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>Events & News</div>
					</div>
				</div>
			</div>
			<!--banner-->
			<!--位置-->
			<div v-if="infoData" class="location_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-icon name="wap-home" class="icon" color="#808080" size="20px" />
				<span @click="goHome" style="cursor: pointer;">Home</span>
				<van-icon name="arrow" class="icon" color="#808080" size="18px" />
				<span @click="goNews" style="cursor: pointer;">News</span>
				<van-icon name="arrow" class="icon" color="#808080" size="18px" />
				<span style="color: #808080;">{{ infoData.title }}</span>
			</div>
			<!--位置-->
			<!--块1-->
			<div class="block_1">
				<div v-if="infoData" class="block_1_main">
					<div class="title"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>{{ infoData.title }}</div>
					<div class="time"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>Release Date:&ensp;{{ initTime(infoData.fabu_time) }}</div>
					<div v-if="infoData.content" class="content_box" v-html="infoData.content"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
					></div>
					<div class="btn_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<van-button color="#006BB3" class="btn_el" @click="goContact">Contact Us</van-button>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import { articleDetail } from '@/api/public.js';
import moment from 'moment';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		if(that.$route.params.newsId) {
			articleDetail({ custom: that.$route.params.newsId }).then(res => {
				that.infoData = res.data;
				document.title = that.infoData.title + ' - Jtests | IVD Active Materials';
				that.isLoading = false;
			});
		}else {
			that.$toast('Parameter exception, failed to obtain details.');
		}
	},
	methods: {
		goContact() {
			this.$router.push('/contact');
		},
		initTime(value) {
			return moment(value * 1000).format('MM-DD-YYYY');
		},
		goNews() {
			this.$router.push('/news');
		},
		goHome() {
			this.$router.push('/');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		padding: 80px 0;
		.block_1_main{
			width: 1140px;
			margin: 0 auto;
			.btn_box{
				padding-top: 20px;
				text-align: center;
				.btn_el{
					padding: 5px 60px 0 60px;
					font-size: 20px;
					border-radius: 6px;
				}
			}
			.content_box{
				padding: 40px 0;
			}
			.time{
				padding-top: 20px;
				color: #808080;
				font-size: 18px;
				text-align: center;
			}
			.title{
				font-size: 40px;
				text-align: center;
			}
		}
	}
	//位置块
	.location_box{
		width: 1140px;
		margin: 0 auto;
		padding-top: 30px;
		.icon{
			top: 4px;
		}
		span{
			display: inline-block;
			padding: 0 5px;
			font-size: 16px;
		}
	}
	//banner
	.banner_box{
		width: 100%;
		max-width: 1920px;
		margin: 0 auto;
		.banner_el{
			position: relative;
			.msg_box{
				width: 100%;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				text-align: center;
				.text{
					font-size: 24px;
					color: #ffffff;
				}
				.title{
					font-size: 56px;
					color: #ffffff;
				}
			}
			img{
				width: 100%;
				min-width: 1140px;
			}
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box img{
	max-width: 100%;
	height: auto;
}
>>> .main_box th{
	padding: 12px;
	background-color: #9F58AE;
	color: #ffffff;
}
>>> .main_box td, >>> .main_box th {
	border: 1px solid #CCCCCC;
	font-size: 16px;
}
>>> .main_box table {
	max-width: 100%;
	border-collapse: collapse;
}
</style>